/**
 * Created by mac on 12/1/24
 */

const VipAdsAdapter = function () {
    cleverapps.EventEmitter.call(this);

    this.saved = {};

    cleverapps.paymentsHistory.onAddPaymentListeners.vip = this.adapt.bind(this);
    cleverapps.subscription.on("update", this.adapt.bind(this));
    cleverapps.flags.on("change:monetization", this.adapt.bind(this));

    this.saved.isRewardedAvailable = RewardedAdsManager.prototype.isRewardedAvailable;
    this.saved.playRewarded = RewardedAdsManager.prototype.playRewarded;

    this.adapt();
};

VipAdsAdapter.prototype = Object.create(cleverapps.EventEmitter.prototype);
VipAdsAdapter.prototype.constructor = VipAdsAdapter;

VipAdsAdapter.prototype.getVIPStatus = function () {
    if (cleverapps.flags.monetization !== cleverapps.Flags.MONETIZATION_REGULAR) {
        return {
            status: false
        };
    }

    if (cleverapps.subscription.isActive()) {
        return {
            status: true,
            end: Date.now() + cleverapps.parseInterval("1 day")
        };
    }

    const end = cleverapps.paymentsHistory.getVipEnd(VipAdsAdapter.VIP_THRESHOLD);
    if (end) {
        return {
            status: true,
            end
        };
    }

    return {
        status: false
    };
};

VipAdsAdapter.VIP_THRESHOLD = 29.99;

VipAdsAdapter.prototype.calculateMinimalVipSum = function () {
    const price = connector.payments.convertPrice(VipAdsAdapter.VIP_THRESHOLD);

    return connector.payments.getTextPrice(Math.ceil(price + 0.01));
};

VipAdsAdapter.prototype.isVIP = function () {
    return this.getVIPStatus().status;
};

VipAdsAdapter.prototype.adapt = function () {
    const status = this.isVIP();

    if (status) {
        RewardedAdsManager.prototype.playRewarded = this.playRewardedVIP.bind(this);
    } else {
        RewardedAdsManager.prototype.playRewarded = this.saved.playRewarded;
    }

    this.trigger("vip_status_changed");
};

VipAdsAdapter.prototype.playRewardedVIP = function (adLimit, onSuccessCallback, onCancelCallback) {
    onSuccessCallback = onSuccessCallback || function () {};
    onCancelCallback = onCancelCallback || function () {};

    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        onSuccessCallback();
        return;
    }

    if (cleverapps.rewardedAdsManager.adIsRunning()) {
        onCancelCallback();

        cleverapps.notification.create(Messages.get("AdsRunning"));
        return;
    }

    if (this.isVIP()) {
        this.playVipRewarded(adLimit, onSuccessCallback, onCancelCallback);
    }
};

VipAdsAdapter.prototype.createWindow = function (onReward) {
    new VIPRewardedWindow(onReward);
};

VipAdsAdapter.prototype.playVipRewarded = function (adLimit, onSuccessCallback, onCancelCallback) {
    cleverapps.rewardedAdsManager._isAdRunning = true;

    let reward = false;

    const onReward = function () {
        reward = true;
    };

    cleverapps.focusManager.display({
        stack: true,
        focus: "VIPRewardWindow",
        actions: [
            (f) => {
                this.createWindow(onReward);
                cleverapps.focusManager.onceNoWindowsListener = f;
            },

            function (f) {
                cleverapps.rewardedAdsManager._isAdRunning = false;

                f();

                if (reward) {
                    cleverapps.eventBus.trigger("taskEvent", "WATCH_ADS");
                    cleverapps.adsLimits.watch(adLimit);
                    onSuccessCallback();
                } else {
                    onCancelCallback();
                }
            }
        ]
    });
};